<template>
  <div :style="style">
    <div class="google-map" ref="googleMap" :style="style"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
          :google="google"
          :map="map"
      />
    </template>
  </div>
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader?async=true'

export default {
  props: {
    mapConfig: Object,
    apiKey: String,
    style: String
  },

  data() {
    return {
      google: null,
      map: null
    }
  },

  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey
    })
    this.google = googleMapApi
    this.initializeMap()
  },

  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(
          mapContainer, this.mapConfig
      )
    }
  }
}

</script>

<style scoped>

</style>
